<template>
    <b-container>
        <b-row>
            <b-col lg="6" md="8">
                <div class="content">
                    <h1>
                        Web
                    </h1>
                    <p>
                        We provide tailored web solutions (websites and web applications) which we can adjust depending on the need and the client.
                    </p>
                    <p>
                        We favorite the use of open source CMS tools such as Joomla! and WordPress, including E-Commerce sites and powerful integrations to payment gateways (including development to custom and local gateways), CRM and E-Learning systems.
                    </p>
                    <p>
                        Our solutions are always focused on empowering users to feed their own websites rather than depending on a developer to perform changes.
                    </p>
                </div>
            </b-col>
            <b-col lg="6" md="4" class="image">
                <img src="../assets/img/web.svg" alt="Web solutions">
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
  export default {
    name: 'Web',
  }
</script>

<style scoped>
</style>